import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./location-search-cemeteries.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./location-search-cemeteries.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { FormControl, FormGroup } from "@angular/forms";
import { AppControllerService } from "../../../app-controller.service";
import { PropertiesConstants } from "../../properties/properties.constants";
import { GraveSearchService } from "../shared/services/grave-search.service";
import { GraveSearchOption } from "../shared/models/grave/grave-search-option.enum";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let LocationSearchCemeteriesComponent = class LocationSearchCemeteriesComponent {
    graveSearchService;
    appController;
    changeDetectorRef;
    valueSelected = new EventEmitter();
    locationCemeteryLabel = PropertiesConstants.FORM_CONTROLS.locationCemeteryLabel;
    locationCemeteryFormControl = PropertiesConstants.FORM_CONTROLS.locationCemeteryFormControl;
    placeholder = SharedConstants.SEARCH_BY_DEFAULT;
    searchText = PropertiesConstants.FORM_CONTROLS.searchText;
    locationCemeteriesForm;
    cemeteries = [];
    setUpFormSubscription;
    constructor(graveSearchService, appController, changeDetectorRef) {
        this.graveSearchService = graveSearchService;
        this.appController = appController;
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        this.setUpForm();
    }
    onChangeCemetery($event) {
        this.valueSelected.emit(this.locationCemeteriesForm.get(this.locationCemeteryFormControl).value);
    }
    setUpForm() {
        this.locationCemeteriesForm = new FormGroup({
            locationCemeteryFormControl: new FormControl(null)
        });
        this.graveSearchService.getCemeteries();
        this.setUpFormSubscription = this.graveSearchService.cemeteryListAsObservable.subscribe((cemeteries) => {
            if (cemeteries) {
                this.cemeteries = [];
                this.cemeteries.push(...cemeteries);
                this.locationCemeteriesForm.get(this.locationCemeteryFormControl).setValue(0);
                // need to reset this for the actual search process
                this.graveSearchService.searchType = GraveSearchOption.Grave;
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    static ctorParameters = () => [
        { type: GraveSearchService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        valueSelected: [{ type: Output }]
    };
};
LocationSearchCemeteriesComponent = __decorate([
    Component({
        selector: "app-location-search-cemeteries",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], LocationSearchCemeteriesComponent);
export { LocationSearchCemeteriesComponent };
